import React, { createContext } from "react";
import {IDemand} from "../demands/demand.interface";


interface DemandContextProps {
    demand: IDemand|null;
    setDemand: React.Dispatch<React.SetStateAction<IDemand>>;
}


export const DemandContext = createContext<DemandContextProps>({
    demand: null,
    setDemand: (demand) => {},
});
